<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        v-if="loadingCompleted"
        :baseView="baseView"
        :primaryLabel="
          baseView.mode == 'create' ? pageData.createTitle : dataModel.Name
        "
        :secondaryLabel="baseView.mode == 'create' ? '' : dataModel.Code"
      />
    </template>
    <gc-form-header-toolbar
      v-if="loadingCompleted"
      :toolbar-options="toolbarOptions"
      :backRoute="pageData.route"
      :itemSaveCallBack="saveData"
      :dataModel="dataModel"
      :baseView="baseView"
    ></gc-form-header-toolbar>

    <div class="responsive-paddings">
      <GcForm
        v-if="loadingCompleted"
        :formOptions="formOptions"
        :formItems="formItems"
        :isNormal="true"
        :data-model="dataModel"
        :formMode="baseView.mode"
        :checkValid="checkValid"
        :valueChangeCallBack="validationCallBack"
        :formContentReady="formContentReady"
      />
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FormViewService } from "@/_services/api/templates/form-view.service.js";

export default {
  props: {
    /**
     * contains report configurations
     */
    toolbarOptions: {
      type: Object,
      default: undefined,
    },
    formItems: {
      type: Array,
      default: () => [],
    },
    backButtonRoute: {
      type: String,
      default: "/home",
    },
    dataModel: {
      type: [Array, Object],
      default: () => {},
    },
    saveModel: {
      type: Object,
      default: undefined,
    },
    pageData: {
      type: Object,
      default: undefined,
    },
    formContentReady: {
      type: Function,
      default: () => {},
    },
  },

  components: {},
  async created() {
    this.initialize();
  },
  mixins: [RouteMixin, FormMixin],
  data() {
    return {
      checkValid: false,
      brokenRules: [],
      loadingCompleted: false,

      formOptions: {
        gcLabelLocation: "left",
      },
    };
  },
  computed: {},

  methods: {
    async initialize() {
      let screenData = {};
      if (this.pageData.local) {
        this.loadingCompleted = true;
        return;
      } else {
        screenData = await FormViewService.getByCode(
          this.pageData.readEndpoint,
          "01",
          this.pageData.expand
        );
      }

      for (const key in screenData.data.value[0]) {
        if (this.dataModel.hasOwnProperty(key)) {
          if (key !== "Image" && key !== "SetAsPostalAddress")
            this.dataModel[key] = screenData.data.value[0][key];
        }
      }

      if (
        screenData.data.value[0].CompanyImagesMetas &&
        screenData.data.value[0].CompanyImagesMetas.length > 0
      ) {
        this.dataModel.ImageSrc = screenData.data.value[0].CompanyImagesMetas.find(
          (x) => x.SizeType == "thumb"
        ).ImageUrl;

        this.dataModel.PreviewImageSrc = screenData.data.value[0].CompanyImagesMetas.find(
          (x) => x.SizeType == "preview"
        ).ImageUrl;

        this.dataModel.OriginalImageBlobName = screenData.data.value[0].CompanyImagesMetas.find(
          (x) => x.SizeType == "original"
        ).BlobName;
      } else {
        this.dataModel["ImageSrc"] = screenData.data.value[0].Image;
      }

      this.loadingCompleted = true;
    },
    async validationCallBack(isValid, brokenRules) {
      if (!isValid) this.displayValidationSummary(brokenRules);
      else {
        for (const key in this.saveModel) {
          this.saveModel[key] = this.dataModel[key];
        }

        this.showLoading(true);

        try {
          let res = await FormViewService.save(
            this.pageData.saveEndpoint,
            this.saveModel
          );

          if (res.status == 201 || res.status == 200) {
            if (this.pageData.local) {
              this.$notify(`Updated successfully`, "Success");
            } else {
              this.$notify(
                `${this.pageData.name} ${res.data.Name} saved successfully`,
                "Success"
              );
            }
          }

          this.showLoading(false);
          this.setIgnoreRouteChangeConfirmation();
          this.initialize();
          if (this.pageData.local) {
            this.$router.push(`${this.pageData.route}`);
          } else {
            this.$router.push(`${this.pageData.route}/review/${res.data.Code}`);
          }
        } catch (err) {
          this.showLoading(false);
          this.displayServerError(err, `${this.pageData.name} save failed`);
        }
      }

      this.checkValid = false;
    },
    backButtonFunction() {
      this.$router.push(this.backButtonRoute);
    },
    async saveData() {
      this.checkValid = true;
    },
  },
};
</script>

<style lang="scss">
.dx-toast-success {
  background: #03a9f4;
}
.view-toolbar .dx-texteditor {
  width: 500px;
}
</style>
